import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";
import { stringRecord } from "./utils";

export const updateOAuthConnectionSchema = z.object({
  oauthConnectionId: z.string(),
  clientId: z.string().optional(),
  clientSecret: z.string().optional(),
  scopes: z.array(z.string()).optional(),
  status: z.literal("obtained_code").optional(),
  code: z.string().optional(),
  codeVerifier: z.string().optional(),
  redirectUri: z.string().optional(),
  configuration: stringRecord.optional(),
});

export const updateOAuthConnection = mutator({
  redactKeys: ["clientId", "clientSecret", "codeVerifier"],
  schema: updateOAuthConnectionSchema,
  resolve: {
    connection: { kind: "oauthConnection", from: "oauthConnectionId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.connection.connectedApps?.[0]?.id ?? "",
    },
  ],
  fn: async ({
    tx,
    args: { connection, clientId, scopes, status, configuration },
  }) => {
    const updates: {
      clientId?: string;
      scopes?: string[];
      status?: "obtained_code";
      updatedAt: number;
    } = {
      updatedAt: Date.now(),
    };

    if (clientId !== undefined) updates.clientId = clientId;
    if (scopes !== undefined) updates.scopes = scopes;
    if (status !== undefined) updates.status = status;

    await tx.mutate.oauthConnections.update({
      id: connection.id,
      ...updates,
    });

    const [connector] = await tx.run(
      zql.connectedApps.where("oauthConnectionId", connection.id)
    );
    if (connector && configuration) {
      const appConfiguration = (connector.configuration ?? {}) as Record<
        string,
        string
      >;
      await tx.mutate.connectedApps.update({
        id: connector.id,
        configuration: { ...appConfiguration, ...configuration },
      });
    }
  },
});
